<template>
<div>
    <HeaderTeam header="ตั้งค่า" :img_header="header_image" link_back="team" />
    <MenuTeamSettingList />
    <PartTimeOTList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamSettingList from '@/components/menuadmin/team/teamsetting/MenuTeamSettingList.vue'
import PartTimeOTList from '@/components/menuadmin/team/teamsetting/PartTimeOTList.vue'
export default {
    name: 'partTimeOT',
    components: {
        HeaderTeam,
        MenuTeamSettingList,
        PartTimeOTList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
